import { Components } from '@mui/material'

export const PaperOverrides = (): Components['MuiPaper'] => ({
  defaultProps: {
    square: true,
    elevation: 0,
  },
})
